import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const { refresh, logout } = useAuth();
  const nav = useNavigate();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw !== confirm) return toast.error("Konfirmasi kata sandi tidak cocok");
    if (newPw.length < 6) return toast.error("Kata sandi minimal 6 karakter");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Kata sandi berhasil diperbarui");
      await refresh();
      nav("/");
    } catch (e2) {
      toast.error(apiErr(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6">
      <div className="w-full max-w-md rounded-3xl border border-slate-800 bg-slate-900 p-8 shadow-2xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/20 text-primary">
            <KeyRound className="h-5 w-5" />
          </div>
          <div>
            <h2 className="font-heading text-xl font-bold text-white">Ganti Kata Sandi</h2>
            <p className="text-xs text-slate-400">Wajib untuk login pertama kali</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-300">Kata Sandi Lama (dari HR)</Label>
            <Input data-testid="old-password-input" type="password" value={oldPw}
              onChange={(e) => setOldPw(e.target.value)}
              className="border-slate-700 bg-slate-800 text-white" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Kata Sandi Baru</Label>
            <Input data-testid="new-password-input" type="password" value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              className="border-slate-700 bg-slate-800 text-white" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Konfirmasi Kata Sandi Baru</Label>
            <Input data-testid="confirm-password-input" type="password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="border-slate-700 bg-slate-800 text-white" />
          </div>
          <Button data-testid="change-password-submit" type="submit" disabled={loading}
            className="h-11 w-full bg-primary font-semibold">
            {loading ? "Menyimpan..." : "Simpan & Lanjutkan"}
          </Button>
          <button type="button" onClick={logout}
            className="w-full text-center text-xs text-slate-500 hover:text-slate-300">
            Keluar
          </button>
        </form>
      </div>
    </div>
  );
}
